<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        نقش‌ها و دسترسی‌ها
      </h4>
    </b-card-header>

    <b-card-body>
      <managed-in-dash-notice />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody } from 'bootstrap-vue'
import ManagedInDashNotice from '@/views/user/components/ManagedInDashNotice.vue'

/**
 * Stands where the role and permission pages used to be, so their menu entry
 * and old links explain where those pages went.
 */
export default {
  name: 'RolesAndPermissionsManagedInDash',
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    ManagedInDashNotice,
  },
}
</script>
